// Mock data for KHAN Portfolio Site

export const brandData = {
  name: "KHAN",
  fullName: "creativedirectorkhan",
  tagline: "creativedirectorkhan",
  available: "Serving Clients Worldwide"
};

export const heroData = {
  headline: "Crafting Visual Stories",
  subheadline: "That Resonate",
  description: "CreativeDirectorKhan | KHAN is a creative agency specializing in content and strategy — partnering with ambitious brands to build, scale, and elevate at every stage of growth."
};

export const aboutData = {
  intro: "Hassaan Khan is the founder of CreativeDirectorKhan | KHAN, a creative agency specializing in content and strategy, partnering with brands at every stage of growth.",
  philosophy: "With over a decade of experience across film production, digital marketing, branding, and web development, Hassaan leads KHAN with a singular focus: delivering precise, high-impact creative work tailored to each client's needs.",
  approach: "KHAN is built to be strategic and adaptable — whether a brand needs strategic planning, full-scale production, or ongoing creative support. From concept to execution, the agency delivers everything needed to build, scale, and elevate a brand under one creative roof."
};

export const servicesData = [
  {
    id: 1,
    category: "Production",
    services: [
      { 
        name: "Film Production", 
        slug: "film-production",
        description: "Director of Photography, 1st AC, Gimbal Operator",
        fullDescription: "Professional cinematography services bringing your vision to life with cutting-edge equipment and decades of expertise.",
        features: ["4K/6K Cinema Cameras", "Professional Lighting", "Gimbal Stabilization", "Drone Cinematography", "Color Grading", "Sound Design"]
      },
      { 
        name: "Wedding Cinematography", 
        slug: "wedding-cinematography",
        description: "Cinematic storytelling for your special day",
        fullDescription: "Capturing the magic, emotion, and beauty of your wedding day with a cinematic approach that tells your unique love story.",
        features: ["Full Day Coverage", "Highlight Films", "Documentary Style", "Drone Footage", "Same-Day Edits", "Multiple Cameras"]
      },
      { 
        name: "Real Estate Media", 
        slug: "real-estate-media",
        description: "HDR photos, video walk-throughs, drone shots",
        fullDescription: "Elevate your property listings with stunning visual content that sells. From luxury homes to commercial spaces.",
        features: ["HDR Photography", "Video Tours", "Aerial Drone Shots", "Virtual Staging", "Floor Plans", "Twilight Shoots"]
      },
      { 
        name: "Event Broadcasting", 
        slug: "event-broadcasting",
        description: "Live streaming and event coverage",
        fullDescription: "Professional multi-camera live streaming and event coverage for conferences, concerts, and corporate events.",
        features: ["Multi-Camera Setup", "Live Switching", "Graphics Overlay", "Platform Integration", "Recording", "Post-Production"]
      }
    ]
  },
  {
    id: 2,
    category: "Digital",
    services: [
      { 
        name: "Website Development", 
        slug: "website-development",
        description: "Shopify, WordPress, custom solutions",
        fullDescription: "Beautiful, functional websites that drive conversions. From e-commerce to custom web applications.",
        features: ["Custom Design", "E-commerce", "CMS Integration", "Mobile Responsive", "SEO Optimized", "Performance Tuned"]
      },
      { 
        name: "SEO Strategies", 
        slug: "seo-strategies",
        description: "Visibility and search ranking optimization",
        fullDescription: "Data-driven SEO strategies that increase your visibility and drive organic traffic to your business.",
        features: ["Keyword Research", "On-Page SEO", "Technical SEO", "Link Building", "Local SEO", "Analytics & Reporting"]
      },
      { 
        name: "Digital Advertising", 
        slug: "digital-advertising",
        description: "Targeted campaigns that drive results",
        fullDescription: "Strategic paid advertising campaigns across Google, Meta, and other platforms to maximize your ROI.",
        features: ["Google Ads", "Meta Ads", "Retargeting", "A/B Testing", "Conversion Tracking", "Budget Optimization"]
      },
      { 
        name: "AI Automations", 
        slug: "ai-automations",
        description: "Streamlined workflows and productivity",
        fullDescription: "Leverage the power of AI to automate repetitive tasks and supercharge your business operations.",
        features: ["Workflow Automation", "Chatbots", "Data Processing", "Content Generation", "Email Automation", "Custom Integrations"]
      }
    ]
  },
  {
    id: 3,
    category: "Creative",
    services: [
      { 
        name: "Brand Identity", 
        slug: "brand-identity",
        description: "Complete brand creation and strategy",
        fullDescription: "Comprehensive brand identity development that captures your essence and resonates with your audience.",
        features: ["Logo Design", "Brand Guidelines", "Color Palette", "Typography", "Brand Voice", "Stationery Design"]
      },
      { 
        name: "Content Creation", 
        slug: "content-creation",
        description: "Impactful content across platforms",
        fullDescription: "Engaging content that tells your story and connects with your audience across all platforms.",
        features: ["Social Media Content", "Blog Writing", "Video Content", "Photography", "Copywriting", "Content Strategy"]
      },
      { 
        name: "Graphic Design", 
        slug: "graphic-design",
        description: "Logos, social assets, print materials",
        fullDescription: "Eye-catching visual designs from digital assets to print materials that make your brand stand out.",
        features: ["Logo Design", "Social Media Graphics", "Print Design", "Packaging", "Infographics", "Marketing Materials"]
      },
      { 
        name: "Motion Graphics", 
        slug: "motion-graphics",
        description: "Animations, intros, and visual effects",
        fullDescription: "Dynamic motion graphics and animations that bring your brand to life and captivate your audience.",
        features: ["Logo Animations", "Explainer Videos", "Title Sequences", "Social Animations", "3D Graphics", "Visual Effects"]
      }
    ]
  },
  {
    id: 4,
    category: "Consulting",
    services: [
      { 
        name: "Media Strategy", 
        slug: "media-strategy",
        description: "Strategic media planning for agencies & businesses",
        fullDescription: "Comprehensive media strategy consulting to help agencies and businesses optimize their media presence and maximize impact.",
        features: ["Media Audits", "Channel Strategy", "Budget Allocation", "Performance Analysis", "Competitive Analysis", "ROI Optimization"]
      },
      { 
        name: "Technology Advisory", 
        slug: "technology-advisory",
        description: "Tech stack evaluation and implementation guidance",
        fullDescription: "Expert technology consulting to help businesses choose, implement, and optimize the right tools and platforms.",
        features: ["Tech Stack Audit", "Platform Selection", "Integration Planning", "Vendor Evaluation", "Digital Transformation", "Cost Analysis"]
      },
      { 
        name: "Budget & Appraisals", 
        slug: "budget-appraisals",
        description: "Project budgeting and value assessments",
        fullDescription: "Detailed project budgeting, cost analysis, and appraisals to ensure your creative investments deliver maximum value.",
        features: ["Project Budgeting", "Cost Estimation", "Value Assessment", "Resource Planning", "Financial Forecasting", "Vendor Negotiation"]
      },
      { 
        name: "Automation Consulting", 
        slug: "automation-consulting",
        description: "Workflow optimization and automation strategy",
        fullDescription: "Strategic consulting to identify automation opportunities and implement efficient workflows across your organization.",
        features: ["Process Mapping", "Automation Roadmap", "Tool Selection", "Implementation Support", "Training", "Performance Tracking"]
      },
      { 
        name: "Content Strategy", 
        slug: "content-strategy",
        description: "Content planning and editorial direction",
        fullDescription: "Comprehensive content strategy development to align your messaging with business goals and audience needs.",
        features: ["Content Audit", "Editorial Calendar", "Voice & Tone", "Distribution Strategy", "Content Pillars", "Measurement Framework"]
      },
      { 
        name: "Audience Audit", 
        slug: "audience-audit",
        description: "Deep audience analysis and insights",
        fullDescription: "In-depth audience research and analysis to understand your customers and optimize your marketing approach.",
        features: ["Demographic Analysis", "Behavioral Insights", "Persona Development", "Journey Mapping", "Segmentation", "Engagement Analysis"]
      }
    ]
  }
];

export const serviceImages = {
  "film-production": {
    hero: "https://images.unsplash.com/photo-1619099619226-f96e319e3732?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1595401735913-4ca17c66e755?w=800&q=80",
      "https://images.unsplash.com/photo-1616469829935-c2f33ebd89b8?w=800&q=80",
      "https://images.unsplash.com/photo-1585814240392-e50b9dc29511?w=800&q=80"
    ]
  },
  "wedding-cinematography": {
    hero: "https://images.unsplash.com/photo-1604017011826-d3b4c23f8914?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1533091090875-1ff4acc497dd?w=800&q=80",
      "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80",
      "https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=800&q=80"
    ]
  },
  "real-estate-media": {
    hero: "https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=800&q=80",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80"
    ]
  },
  "event-broadcasting": {
    hero: "https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80",
      "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=800&q=80"
    ]
  },
  "website-development": {
    hero: "https://images.unsplash.com/photo-1481487196290-c152efe083f5?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1707836885254-79b6e3d7b18d?w=800&q=80",
      "https://images.unsplash.com/photo-1519222970733-f546218fa6d7?w=800&q=80",
      "https://images.unsplash.com/photo-1547658719-da2b51169166?w=800&q=80"
    ]
  },
  "seo-strategies": {
    hero: "https://images.unsplash.com/photo-1562577309-4932fdd64cd1?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
      "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&q=80"
    ]
  },
  "digital-advertising": {
    hero: "https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&q=80",
      "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80",
      "https://images.unsplash.com/photo-1557838923-2985c318be48?w=800&q=80"
    ]
  },
  "ai-automations": {
    hero: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&q=80",
      "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=800&q=80",
      "https://images.unsplash.com/photo-1555255707-c07966088b7b?w=800&q=80"
    ]
  },
  "brand-identity": {
    hero: "https://images.unsplash.com/photo-1636247499734-893da2bcfc1c?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1636247498175-d2a8d052c2b0?w=800&q=80",
      "https://images.unsplash.com/photo-1636247499742-acfa31ac2b12?w=800&q=80",
      "https://images.unsplash.com/photo-1558655146-d09347e92766?w=800&q=80"
    ]
  },
  "content-creation": {
    hero: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1542744094-3a31f272c490?w=800&q=80",
      "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
      "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800&q=80"
    ]
  },
  "graphic-design": {
    hero: "https://images.unsplash.com/photo-1626785774573-4b799315345d?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=800&q=80",
      "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&q=80",
      "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=800&q=80"
    ]
  },
  "motion-graphics": {
    hero: "https://images.unsplash.com/photo-1634618948828-aa7b3d0724fd?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1645255932563-b106c8c57c7c?w=800&q=80",
      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800&q=80",
      "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&q=80"
    ]
  },
  "media-strategy": {
    hero: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1531538606174-0f90ff5dce83?w=800&q=80",
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80",
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80"
    ]
  },
  "technology-advisory": {
    hero: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1504384764586-bb4cdc1707b0?w=800&q=80",
      "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=800&q=80",
      "https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80"
    ]
  },
  "budget-appraisals": {
    hero: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
      "https://images.unsplash.com/photo-1586282391129-76a6df230234?w=800&q=80",
      "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800&q=80"
    ]
  },
  "automation-consulting": {
    hero: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a?w=800&q=80",
      "https://images.unsplash.com/photo-1555255707-c07966088b7b?w=800&q=80",
      "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=800&q=80"
    ]
  },
  "content-strategy": {
    hero: "https://images.unsplash.com/photo-1432821596592-e2c18b78144f?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&q=80",
      "https://images.unsplash.com/photo-1455390582262-044cdead277a?w=800&q=80",
      "https://images.unsplash.com/photo-1542435503-956c469947f6?w=800&q=80"
    ]
  },
  "audience-audit": {
    hero: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
      "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&q=80",
      "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=800&q=80"
    ]
  }
};

export const expertiseData = [
  "Premiere Pro",
  "DaVinci Resolve",
  "After Effects",
  "Photoshop",
  "Lightroom",
  "Illustrator",
  "Figma",
  "Cinema 4D"
];

export const statsData = [
  { value: "10+", label: "Years" },
  { value: "500+", label: "Projects" },
  { value: "200+", label: "Clients" }
];

export const contactInfo = {
  availability: "Serving Clients Worldwide"
};
